export const MOBILE_55_VIDEO_ID = 'n35rhk1hpj';
export const DESKTOP_VIDEO_ID = 'yl7n54m33e';
export const APP_DOWNLOAD_LINK_APP_PAGE = 'https://goat.onelink.me/YLrx/lzxjv31c';
export const BG_IMG_LG = 'https://cms-cdn.goat.com/3000/26e5ecd50b56-0b79-fe11-990a-03bf6520.jpg';
export const HERO_IMG_LG = 'https://cms-cdn.goat.com/3000/26e5ecd50b56-0b79-fe11-990a-036d5433.jpg';
export const HERO_IMG_SM = 'https://cms-cdn.goat.com/3000/fa86bfdd2bfa-5389-fe11-990a-02671bd2.jpg';
export const QR_CODE = 'https://cms-cdn.goat.com/3000/285462574d57-13aa-1f11-941b-0d14b6a8.png';
